/* sm-vs-bustadur.js - "Oryggisnumer a sumarhus" adapter for the one page kit (adapter 'bustadur').
   Modeled on postkassi/src/sm-vs-postkassi.js (same window.SMVelSida.skra(name, A) contract: gerd,
   upphaf, hlada, teikna, lysing, athuga, eiginleikar, framleidsla, skref). Unlike postkassi this line
   has NO variable drawing at all except one field: the customer's security number (6-8 digits, shown
   "231 8475"). Every other mark on the plate - IS/EN titles, the 112 box, the horizontal rule, the
   outer cut, the 4 corner holes - is the owner's OWN approved artwork (SPEC.md,
   bustadur/eigandi-hoenun-300x75.svg + tillogur2/A-EN3-300x75-svart-akryl.svg + A-200x60-v2.svg +
   A-EN-200x60.svg), reused byte-identical: bustadur/scripts/extract_static.py flattened each approved
   file's paths (minus the one <g> holding the demo number's 7 digit paths, found structurally - it is
   the only group with exactly 7 direct <path> children) into absolute plate-mm 'd' data, once, into
   src/sm-bustadur-static.json (fetched at runtime, never re-derived here). See README.md for how the
   4 variants' number anchors (cx / baseline y / cap height in mm) were measured directly off the
   approved SVGs in a real browser (getBBox + the accumulated transform chain), not guessed.

   The number itself is drawn TWICE, on purpose, the same way every SMFram-based line on the kit draws
   variable text:
     - PREVIEW (teikna): a plain <text font-family="Montserrat"> element, sized/positioned from the
       same anchor table - fast, no outlining needed just to look right on screen.
     - PRODUCTION (framleidsla): window.SMFram.texti(nr, 'montserrat-500', mm, cx, y, {jofnun:'midja'})
       - the kit's own outline font asset (thema-afrit/assets/sm-letur-montserrat-500.json, already
         used by hurdaskilti/gaeludyr/etc, confirmed against the approved artwork: capHeight/upem for
         this font is exactly 0.7, and mm = capHeight/0.7 reproduces the owner's own number sizes to
         better than 0.1mm - see README "Letur og staerdir"). This is a real 'texti' GRAFA element in
         the shared pipeline, so it goes through window.SMFram.senda like every other line - no
         bespoke font handling here, no download, nothing invented.
   Holes (15.10, owner: no plugs, "enough with two holes, may be an option of 2 or 4 holes"): Festing is one of
   "Got (2)" (the default: two holes, centred vertically on the left and right side, same x and radius as the corner
   holes), "Got (4)" (the static table's 4 corner circles, exactly what the old "Gat" produced) or "An gata, med limi"
   (no holes). Screws come with holes. No plugs and no surcharge on this line any more. No frame: two-tone
   acrylic 1,6mm normally gets a frame OPTION (FRAME RULE), but the owner's SPEC.md for this line does
   not offer one (the approved artwork has none) - so, like postkassi, this adapter never emits RAMMI.
   ES5, ASCII only, no network calls except the one same-origin fetch for sm-bustadur-static.json. */
(function () {
  'use strict';
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function r3(n) { return Math.round(n * 1000) / 1000; }

  /* ------------------------------------------------------------------
     1. PRODUCT FACTS (SPEC.md, owner 2026-09-30)
     ------------------------------------------------------------------ */
  var STAERDIR = {
    '300x75': { key: '300x75', nafn: '30 x 7,5 cm', w: 300, h: 75 },
    '200x60': { key: '200x60', nafn: '20 x 6 cm', w: 200, h: 60 }
  };
  var STAERD_SJALFGEFIN = '300x75';
  var TUNGUMAL_SJALFGEFID = 'is';
  var FESTING_SJALFGEFID = 'gat2';
  /* holes by Festing. 'gat4' = the 4 corner circles of the approved artwork; 'gat2' = the left and right ones moved to the vertical middle
     (same x and radius); 'gat' is the old name of 'gat4' (kept so an old caller of framleidslaSpec gets the same file as before 15.10) */
  function gotListi(v, festing, St) {
    if (!v || !v.holes || festing === 'an-gata') return [];
    if (festing === 'gat4' || festing === 'gat') return v.holes;
    var xs = v.holes.map(function (h) { return h.cx; }), lo = Math.min.apply(null, xs), hi = Math.max.apply(null, xs), r = v.holes[0].r;
    return [{ cx: lo, cy: r3(St.h / 2), r: r }, { cx: hi, cy: r3(St.h / 2), r: r }];
  }
  var CAP_RATIO = 0.7; /* montserrat-500 sCapHeight/unitsPerEm, measured off sm-letur-montserrat-500.woff */

  /* Two-tone colors: same fallback table shape as postkassi's LOKA_EFNI (window.SMBarm.EFNI wins when
     that engine is on the page). Aluminium is not two-tone (single brushed-metal tile), handled apart. */
  var LOKA_EFNI = {
    'tvilitt-gull':        { flotur: '#dcb381', kjarni: '#1a1815', kantur: '#2b2722' },
    'tvilitt-silfur':      { flotur: '#bcc6c1', kjarni: '#1a1815', kantur: '#2b2c2c' },
    'tvilitt-svart':       { flotur: '#080b0a', kjarni: '#ffffff', kantur: '#e6e6e2' },
    'tvilitt-hvitt':       { flotur: '#fcfbfc', kjarni: '#1a1815', kantur: '#24221f' },
    'tvilitt-blatt':       { flotur: '#0a5d8a', kjarni: '#ffffff', kantur: '#eef0f2' },
    'tvilitt-rautt':       { flotur: '#df0e25', kjarni: '#ffffff', kantur: '#f0eded' },
    'tvilitt-gult':        { flotur: '#fae63d', kjarni: '#1c1c1e', kantur: '#1f1f21' },
    'tvilitt-graent':      { flotur: '#0f7f33', kjarni: '#ffffff', kantur: '#edf0ee' },
    'tvilitt-hvitt-blatt': { flotur: '#fcfbfc', kjarni: '#192757', kantur: '#2f3d68' }
  };
  var EFNI_ROD = ['tvilitt-hvitt', 'tvilitt-svart', 'tvilitt-gull', 'tvilitt-silfur', 'tvilitt-blatt', 'tvilitt-rautt', 'tvilitt-gult', 'tvilitt-graent', 'tvilitt-hvitt-blatt'];
  /* 02.10 (owner): aluminium is black, the engraved marks show bare brushed metal: the Owala bottle preview's steel
     image (assets/sm-brusi-stal.webp) as an SVG pattern the marks and the number are filled with (preview only,
     the production file is unchanged). Plate black, cut edge light grey. */
  var AL = { flotur: '#0d0d0d', kjarni: 'url(#smAlStal)', kantur: '#8a9096' };
  function alStalUrl() { try { var u = String((window.SMBustadur && window.SMBustadur.staticUrl) || ''); return u ? u.replace(/[^\/?]*(\?.*)?$/, '') + 'sm-brusi-stal.webp' : ''; } catch (e) { return ''; } }
  function alDefs(w, h) {
    var u = alStalUrl();
    if (!u) return '<defs><linearGradient id="smAlStal' + w + '" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#cfd3d6"/><stop offset=".4" stop-color="#f1f3f4"/><stop offset="1" stop-color="#bfc4c8"/></linearGradient></defs>';
    return '<defs><pattern id="smAlStal' + w + '" patternUnits="userSpaceOnUse" x="0" y="0" width="' + w + '" height="' + h + '"><rect x="0" y="0" width="' + w + '" height="' + h + '" fill="#e4e7e9"/>' +
      '<image href="' + u + '" x="' + (-h) + '" y="0" width="' + h + '" height="' + w + '" preserveAspectRatio="none" transform="rotate(-90)" opacity=".62"/></pattern></defs>';
  }
  var EFNI_SJALFGEFID = 'al';
  function efniTafla() { return (window.SMBarm && window.SMBarm.EFNI) || LOKA_EFNI; }
  function efni(k) { if (k === 'al') return AL; return efniTafla()[k] || LOKA_EFNI[k] || LOKA_EFNI[EFNI_ROD[0]]; }
  function erAl(k) { return k === 'al'; }

  /* ------------------------------------------------------------------
     2. STATIC ARTWORK (fetched once; see src/sm-bustadur-static.json + README "Letur og staerdir")
     ------------------------------------------------------------------ */
  var STATIC = null, STATIC_P = null;
  function variantKey(staerdKey, tungumal) { return tungumal + '-' + staerdKey; }
  function stadaVaentanleg() { return !!STATIC; }
  function hladaStatic() {
    if (STATIC_P) return STATIC_P;
    var url;
    try { url = (window.SMBustadur && window.SMBustadur.staticUrl) || (document.currentScript && document.currentScript.src.replace(/sm-vs-bustadur\.js.*$/, 'sm-bustadur-static.json')); } catch (e) {}
    if (!url) url = 'sm-bustadur-static.json';
    STATIC_P = fetch(url).then(function (r) { if (!r.ok) throw new Error('static-vantar'); return r.json(); }).then(function (j) { STATIC = j; return j; }).catch(function () { STATIC = null; });
    return STATIC_P;
  }

  /* ------------------------------------------------------------------
     3. NUMBER VALIDATION (SPEC.md: 6-8 digits, shown "XXX XXXX")
     ------------------------------------------------------------------ */
  function hreinsaNumer(s) { return String(s == null ? '' : s).replace(/\D/g, '').slice(0, 8); }
  function birtaNumer(digits) { if (digits.length <= 3) return digits; return digits.slice(0, 3) + ' ' + digits.slice(3); }
  function numerGilt(digits) { return digits.length >= 6 && digits.length <= 8; }

  /* ------------------------------------------------------------------
     4. DRAWING (preview SVG). Static fragments are already absolute plate-mm 'd'/rect data; the
        number is the only thing computed here (plain <text>, real Montserrat webfont, jofnun='midja'
        emulated with text-anchor="middle").
     ------------------------------------------------------------------ */
  function teiknaKassi(w, h) { return '<rect x="0" y="0" width="' + w + '" height="' + h + '" fill="none" stroke="currentColor" stroke-width="0.6" opacity="0.35"/>'; }
  function teiknaStatic(v, litur) {
    if (!v) return '';
    var out = '', i, fr;
    for (i = 0; i < v.staticFrags.length; i++) {
      fr = v.staticFrags[i];
      /* evenodd: the owner's xTool file draws the 112 frame and the bar under it (with the text as holes) as evenodd
         paths; extract_static.py dropped that, so the frame filled solid and hid the 112 digits (same colour). */
      if (fr.type === 'path') out += '<path d="' + fr.d + '" fill="' + litur + '" fill-rule="evenodd"/>';
      else out += '<rect x="' + fr.x + '" y="' + fr.y + '" width="' + fr.w + '" height="' + fr.h + '" fill="' + litur + '"/>';
    }
    return out;
  }
  function teiknaGot(v, litur) {
    if (!v) return '';
    var out = '', i, h;
    for (i = 0; i < v.holes.length; i++) { h = v.holes[i]; out += '<circle cx="' + h.cx + '" cy="' + h.cy + '" r="' + h.r + '" fill="none" stroke="' + litur + '" stroke-width="0.4"/>'; }
    return out;
  }
  /* 07.10 (owner): while the field is empty the preview shows the sample number (ord numer_daemi, "231 8475")
     engraved in full like the 112 mark (owner 07.10: the faint .32 sample was barely visible); the production file never gets it (framleidslaSpec only
     draws the typed digits, and athuga blocks the cart until 6-8 digits are in). */
  function teiknaNumer(v, digits, litur, synishorn) {
    if (!v) return '';
    var g = v.numberGeom, txt = digits ? birtaNumer(digits) : birtaNumer(hreinsaNumer(synishorn));
    if (!txt) return '';
    return '<text x="' + g.cx + '" y="' + g.baselineY + '" font-family="Montserrat, sans-serif" font-weight="500" font-size="' + g.fontSizeMm + '" text-anchor="middle" fill="' + litur + '">' + esc(txt) + '</text>';
  }
  /* Real through-holes: the plate is drawn inside a mask with the holes cut out (the wall behind shows through),
     plus the cut edge and a soft inner shadow (upper-left, as if the plate had thickness). Preview only. */
  function gotDefs(holur, id) {
    var i, h, m = '', k = '';
    for (i = 0; i < holur.length; i++) { h = holur[i]; m += '<circle cx="' + h.cx + '" cy="' + h.cy + '" r="' + h.r + '" fill="#000"/>'; k += '<circle cx="' + h.cx + '" cy="' + h.cy + '" r="' + h.r + '"/>'; }
    return { mask: '<mask id="smGatM' + id + '" maskUnits="userSpaceOnUse" x="-1" y="-1" width="9999" height="9999"><rect x="-1" y="-1" width="9999" height="9999" fill="#fff"/>' + m + '</mask>',
      clip: '<clipPath id="smGatK' + id + '">' + k + '</clipPath>' };
  }
  function teiknaGotKantur(holur, litur, id) {
    var i, h, sk = '', br = '';
    for (i = 0; i < holur.length; i++) {
      h = holur[i];
      sk += '<circle cx="' + r3(h.cx + 0.45) + '" cy="' + r3(h.cy + 0.55) + '" r="' + r3(h.r + 0.55) + '" fill="none" stroke="#000" stroke-opacity=".5" stroke-width="1"/>';
      br += '<circle cx="' + h.cx + '" cy="' + h.cy + '" r="' + h.r + '" fill="none" stroke="' + litur + '" stroke-opacity=".75" stroke-width="0.3"/>';
    }
    return '<g clip-path="url(#smGatK' + id + ')">' + sk + '</g>' + br;
  }
  function teiknaSkilti(staerdKey, tungumal, digits, efniKey, festing, pre) {
    var St = STAERDIR[staerdKey] || STAERDIR[STAERD_SJALFGEFIN];
    var v = STATIC && STATIC[variantKey(staerdKey, tungumal)];
    var m = erAl(efniKey) ? { flotur: AL.flotur, kjarni: 'url(#smAlStal' + St.w + ')', kantur: AL.kantur } : efni(efniKey);
    var holur = gotListi(v, festing, St), medGot = !!v && holur.length > 0, gd = null, id = (pre || 't') + St.w;
    var body = (erAl(efniKey) ? alDefs(St.w, St.h) : '');
    if (medGot) { gd = gotDefs(holur, id); body += '<defs>' + gd.mask + gd.clip + '</defs>'; }
    body += (medGot ? '<g mask="url(#smGatM' + id + ')">' : '') + '<rect x="0" y="0" width="' + St.w + '" height="' + St.h + '" fill="' + m.flotur + '" stroke="' + m.kantur + '" stroke-width="0.6"/>';
    if (!v) { body += teiknaKassi(St.w, St.h); return body; }
    body += teiknaStatic(v, m.kjarni);
    body += teiknaNumer(v, digits, m.kjarni, digits ? '' : t('numer_daemi'));
    if (medGot) body += '</g>' + teiknaGotKantur(holur, m.kantur, id);
    return body;
  }

  /* ------------------------------------------------------------------
     5. PRODUCTION (_framleidsla via window.SMFram). 1 unit = 1mm. Layers: GRAFA (static marks + the
        number text), SKERA-YTRA (outer cut), gat/SKERA-INNRA x2 or x4 (holes, by Festing; none for 'an-gata').
     ------------------------------------------------------------------ */
  function framleidslaSpec(staerdKey, tungumal, digits, efniKey, festing, ord) {
    var St = STAERDIR[staerdKey] || STAERDIR[STAERD_SJALFGEFIN];
    var v = STATIC && STATIC[variantKey(staerdKey, tungumal)];
    var win = (typeof window !== 'undefined') ? window : null;
    var F = win && win.SMFram;
    var hl = [], i, fr, h, g;
    if (v) {
      for (i = 0; i < v.staticFrags.length; i++) {
        fr = v.staticFrags[i];
        if (fr.type === 'path') hl.push(F ? F.slod(fr.d, 'GRAFA') : { gerd: 'slod', lag: 'GRAFA', d: fr.d });
        else hl.push(F ? F.rett(fr.x, fr.y, fr.w, fr.h, 0, 'GRAFA') : { gerd: 'rett', lag: 'GRAFA', x: fr.x, y: fr.y, w: fr.w, h: fr.h, r: 0 });
      }
      g = v.numberGeom;
      hl.push(F ? F.texti(birtaNumer(digits), 'montserrat-500', r3(g.fontSizeMm), r3(g.cx), r3(g.baselineY), { jofnun: 'midja' })
                : { gerd: 'texti', lag: 'GRAFA', texti: birtaNumer(digits), letur: 'montserrat-500', mm: r3(g.fontSizeMm), x: r3(g.cx), y: r3(g.baselineY), jofnun: 'midja' });
      var holur = gotListi(v, festing, St);
      for (i = 0; i < holur.length; i++) {
        h = holur[i];
        hl.push(F ? F.gat(h.cx, h.cy, h.r) : { gerd: 'hringur', lag: 'SKERA-INNRA', cx: h.cx, cy: h.cy, r: h.r });
      }
    }
    hl.push(F ? F.rett(0, 0, St.w, St.h, 0, 'SKERA-YTRA') : { gerd: 'rett', lag: 'SKERA-YTRA', x: 0, y: 0, w: St.w, h: St.h, r: 0 });
    return {
      vara: 'bustadur', efni: efniKey, staerd: staerdKey, tungumal: tungumal, snid: 'bustadur@1',
      w: St.w, h: St.h,
      lysing: [
        [ord.eig_numer || 'Oryggisnumer', birtaNumer(digits)],
        [ord.eig_tungumal || 'Tungumal', tungumal === 'en' ? (ord.tungumal_en || 'Med ensku') : (ord.tungumal_is || 'Adeins islenska')],
        [ord.eig_festing || 'Festing', festing === 'an-gata' ? (ord.festing_an || 'An gata, med limi') : ((festing === 'gat4' || festing === 'gat') ? (ord.festing_gat4_eig || 'Got (4), skrufur og murtappar fylgja') : (ord.festing_gat2_eig || 'Got (2), skrufur og murtappar fylgja'))]
      ],
      hlutir: hl
    };
  }

  /* ------------------------------------------------------------------
     6. ADAPTER STATE + SMVelSida CONTRACT
     ------------------------------------------------------------------ */
  var CTX = null, ST = { staerd: STAERD_SJALFGEFIN, efni: EFNI_SJALFGEFID, tungumal: TUNGUMAL_SJALFGEFID, festing: FESTING_SJALFGEFID, numer: '', snert: false };
  function V() { return (CTX && CTX.vel) || {}; }
  function ORD() { return V().ord || {}; }
  function t(k, b) { var s = ORD()[k]; s = s == null ? k : String(s); if (b) s = s.replace(/\{(\w+)\}/g, function (m, n) { return b[n] != null ? String(b[n]) : m; }); return s; }

  /* L1 23.10: ensku heitin (/en) líka, annars teiknaði /en alltaf Ál 30 x 7,5 og framleiðsluskráin fékk rangt efni/stærð */
  var STAERD_NAFN = { '30 x 7,5 cm': '300x75', '20 x 6 cm': '200x60', '30 x 7.5 cm': '300x75' };
  var EFNI_PAT_TXT = { 'ál': 'al', 'hvítt/blátt': 'tvilitt-hvitt-blatt', 'hvítt': 'tvilitt-hvitt', 'svart': 'tvilitt-svart', 'gull': 'tvilitt-gull', 'silfur': 'tvilitt-silfur', 'blátt': 'tvilitt-blatt', 'rautt': 'tvilitt-rautt', 'gult': 'tvilitt-gult', 'grænt': 'tvilitt-graent',
    'aluminium': 'al', 'aluminum': 'al', 'white/blue': 'tvilitt-hvitt-blatt', 'white': 'tvilitt-hvitt', 'black': 'tvilitt-svart', 'gold': 'tvilitt-gull', 'silver': 'tvilitt-silfur', 'blue': 'tvilitt-blatt', 'red': 'tvilitt-rautt', 'yellow': 'tvilitt-gult', 'green': 'tvilitt-graent' };
  function checkedNafn(lykill, rot) {
    var el = (rot || document).querySelector('[data-lykill="' + lykill + '"] input:checked');
    return el ? (el.getAttribute('data-nafn') || el.value) : null;
  }
  function samstillaAfNativum(ctx) {
    var rot = (ctx && ctx.rot) || document;
    var st = checkedNafn('staerd', rot);
    if (st && STAERD_NAFN[st]) ST.staerd = STAERD_NAFN[st];
    var lit = checkedNafn('efni', rot);
    if (lit) {
      var low = String(lit).toLowerCase(), k, fundid;
      for (k in EFNI_PAT_TXT) if (has(EFNI_PAT_TXT, k) && low.indexOf(k) >= 0) { fundid = EFNI_PAT_TXT[k]; break; }
      if (fundid) ST.efni = fundid;
    }
  }

  /* 15.10: Festing is 'gat2' | 'gat4' | 'an-gata' */
  function festingTexti() { return ST.festing === 'an-gata' ? (ORD().festing_an_syn || t('festing_an')) : (ST.festing === 'gat4' ? t('festing_gat4') : t('festing_gat2')); }
  function festingEig() { return ST.festing === 'an-gata' ? t('festing_an') : (ST.festing === 'gat4' ? t('festing_gat4_eig') : t('festing_gat2_eig')); }
  function setjaFesting(f) { ST.festing = (f === 'gat4' || f === 'an-gata') ? f : 'gat2'; }

  function numerVandamal() {
    var d = hreinsaNumer(ST.numer);
    if (!d) return { kodi: 'vantar_numer', texti: t('villa_vantar_numer') };
    if (!numerGilt(d)) return { kodi: 'rangur_fjoldi', texti: t('villa_fjoldi_stafa') };
    return null;
  }

  var A = {
    gerd: 'svg', skuggi: false, lifandi: true,
    upphaf: function (ctx) { CTX = ctx; if (erTakkar(ctx) && ctx.takkar) takkaBar = takkaSmida(ctx); hladaStatic().then(function () { try { ctx.breytt(); } catch (e) {} }); },
    hlada: function (ctx) { CTX = ctx; return hladaStatic(); },
    teikna: function (ctx) {
      CTX = ctx;
      samstillaAfNativum(ctx);
      var digits = hreinsaNumer(ST.numer);
      var body = teiknaSkilti(ST.staerd, ST.tungumal, digits, ST.efni, ST.festing, '');
      var St = STAERDIR[ST.staerd];
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + St.w + ' ' + St.h + '" preserveAspectRatio="xMidYMid meet" role="img" aria-hidden="true" focusable="false">' + body + '</svg>';
      if (ctx.teikning.__bsSvg !== svg) { ctx.teikning.innerHTML = svg; ctx.teikning.__bsSvg = svg; }
      if (takkaBar) takkaBar.uppfaera();
    },
    lysing: function () {
      samstillaAfNativum(CTX);
      return t('aria', { numer: birtaNumer(hreinsaNumer(ST.numer)) || '?', staerd: STAERDIR[ST.staerd].nafn });
    },
    /* 14.10 (samraeming): "Daemi" flagan a myndinni (kitid teiknar hana) medan synishornid er teiknad en ekkert hefur verid skrifad */
    daemi: function (s, ctx) { return !hreinsaNumer(ST.numer) ? ((ctx && ctx.vel && ctx.vel.ord && ctx.vel.ord.daemi_merki) || 'Dæmi, sláðu inn þitt númer') : false; },
    malband: function () { var St = STAERDIR[ST.staerd]; return { b: St.w / 10, h: St.h / 10, eining: 'cm' }; },
    smamynd: function () {
      var St = STAERDIR[ST.staerd];
      return { svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + St.w + ' ' + St.h + '">' + teiknaSkilti(ST.staerd, ST.tungumal, hreinsaNumer(ST.numer), ST.efni, ST.festing, 's') + '</svg>' };
    },
    veggur: function () { return erAl(ST.efni) ? 'ljos' : (({ 'tvilitt-svart': 1 })[ST.efni] ? 'dokkur' : 'ljos'); },
    athuga: function () {
      samstillaAfNativum(CTX);
      var ut = [], v = numerVandamal();
      if (v) ut.push({ kodi: v.kodi, reitur: 'numer', stopp: true, texti: v.texti, hnappur: v.texti, strax: ST.snert });
      return ut;
    },
    eiginleikar: function (s, ctx) {
      samstillaAfNativum(CTX);
      var ut = [];
      ut.push([t('eig_numer'), birtaNumer(hreinsaNumer(ST.numer))]);
      ut.push([t('eig_tungumal'), ST.tungumal === 'en' ? t('tungumal_en') : t('tungumal_is')]);
      ut.push([t('eig_staerd'), STAERDIR[ST.staerd].nafn]);
      /* 15.10: "Got (2)" | "Got (4)" | "An gata, med limi"; no Tappar property any more, so sm-magnafslattur.js / sm-cart.liquid add no fee line here */
      ut.push([t('eig_festing'), festingEig()]);
      /* 07.10: the kit's notes step (an array from eiginleikar is the WHOLE list, so the note has to be here; same cart name as before) */
      var aths = String(s && s.aths != null ? s.aths : '').replace(/^\s+|\s+$/g, '');
      if (aths) ut.push([(ctx && ctx.eiginleiki('aths')) || 'Athugasemdir með pöntun', aths]);
      return ut;
    },
    framleidsla: function () { samstillaAfNativum(CTX); return framleidslaSpec(ST.staerd, ST.tungumal, hreinsaNumer(ST.numer), ST.efni, ST.festing, ORD()); },
    /* 07.10 (efnisflísar): hver flís í skrefinu Efni er teikning skiltisins úr vélinni í því efni (sama stærð, tungumál og festing og
       forskoðunin; númerið sem er slegið inn, annars dæmi). Ekkert er teiknað ef efnið þekkist ekki: þá heldur flísin varamynd sinni. */
    utlit: {
      teikna: function (s2, ctx, o) {
        /* o.gildi er gildi valkostsins (númer), nafnið á efninu er á radio-hnappnum (data-nafn) */
        var nafn = String((o && o.gildi) || ''), rod = (ctx && ctx.rot) || document, el;
        try { el = rod.querySelector('[data-lykill="efni"] input[value="' + nafn.replace(/"/g, '') + '"],[data-vs-utlit="efni"] input[value="' + nafn.replace(/"/g, '') + '"]'); } catch (e) { el = null; }
        if (el && el.getAttribute('data-nafn')) nafn = el.getAttribute('data-nafn');
        var low = nafn.toLowerCase(), k, fundid;
        for (k in EFNI_PAT_TXT) if (has(EFNI_PAT_TXT, k) && low.indexOf(k) >= 0) { fundid = EFNI_PAT_TXT[k]; break; }
        if (!fundid) return null;
        CTX = CTX || ctx; samstillaAfNativum(ctx);
        var St = STAERDIR[ST.staerd], d = hreinsaNumer(ST.numer) || '2318475';
        if (!numerGilt(d)) d = '2318475';
        /* flís má ekki fara yfir 40 KB: slóðirnar í 0,1 mm nákvæmni (flísin er ~100 px á breidd, svo ekkert sést) */
        var body = teiknaSkilti(ST.staerd, ST.tungumal, d, fundid, ST.festing, (o && o.id) || 's').replace(/ d="([^"]*)"/g, function (m, dd) {
          return ' d="' + dd.replace(/-?\d+\.\d+/g, function (n) { return String(Math.round(parseFloat(n) * 10) / 10); }) + '"';
        });
        return { svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + St.w + ' ' + St.h + '" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">' + body + '</svg>' };
      },
      lykill: function () { return [ST.staerd, ST.tungumal, hreinsaNumer(ST.numer), ST.festing].join('|'); }
    },
    skref: {
      numer: {
        teikna: function (el, s, ctx) { smidaNumer(el, ctx); },
        gildi: function () { return birtaNumer(hreinsaNumer(ST.numer)) || ''; },
        buid: function () { return !numerVandamal(); }
      },
      tungumal: {
        teikna: function (el, s, ctx) { smidaVal(el, ctx, 'tungumal', [['is', ORD().tungumal_is_syn || t('tungumal_is')], ['en', ORD().tungumal_en_syn || t('tungumal_en')]], function (v) { ST.tungumal = v; }, function () { return ST.tungumal; }); },
        gildi: function () { return ST.tungumal === 'en' ? (ORD().tungumal_en_syn || t('tungumal_en')) : (ORD().tungumal_is_syn || t('tungumal_is')); },
        buid: function () { return true; }
      },
      festing: {
        teikna: function (el, s, ctx) { smidaVal(el, ctx, 'festing', [['gat2', t('festing_gat2')], ['gat4', t('festing_gat4')], ['an-gata', ORD().festing_an_syn || t('festing_an')]], setjaFesting, function () { return ST.festing; }); },
        gildi: function () { return festingTexti(); },
        buid: function () { return true; }
      }
    }
  };

  /* Kit units (lota 7, 08.10): a labelled number field (K-reitur, label for screen readers only: the step heading says it; the help line and the
     error come from the kit's own sersnid step, hjalp in the template and athuga() above, so nothing is shown twice - owner 07.10) and a
     2-choice group (ctx.html.kostir, pills like the Staerd step) reused for 'tungumal' and 'festing'. The adapter keeps its state and listens by delegation. */
  function smidaNumer(el, ctx) {
    if (!el.__bsBuilt) {
      el.__bsBuilt = true;
      var id = 'vs-' + ctx.id + '-bs-numer';
      ctx.html.setja(el, ctx.html.reitur({ id: id, heiti: t('numer_heiti'), sjonlaust: true, gerd: 'tala', hamark: 9, teljari: false, villa: false,
        synishorn: t('numer_daemi'), fokus: 'bs-numer', attr: { autocomplete: 'off' }, gogn: { 'bs-numer': true } }));
      el.addEventListener('input', function (e) {
        if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-bs-numer')) return;
        var digits = hreinsaNumer(e.target.value);
        e.target.value = birtaNumer(digits);
        ST.numer = digits; ST.snert = true; ctx.breytt();
      });
    }
    var inp = el.querySelector('[data-bs-numer]');
    if (inp && document.activeElement !== inp) inp.value = birtaNumer(hreinsaNumer(ST.numer));
  }
  function smidaVal(el, ctx, lykill, kostir, setja, lesa) {
    var nafn = 'bs-' + lykill + '-' + ctx.id;
    if (!el['__bsVal_' + lykill]) {
      el['__bsVal_' + lykill] = true;
      el.addEventListener('change', function (e) {
        var r = e.target;
        if (r && r.name === nafn && r.checked) { setja(r.value); ctx.breytt(); }
      });
    }
    ctx.html.setja(el, ctx.html.kostir({ nafn: nafn, birting: 'pillur', dalkar: kostir.length, klasi: 'vs-bustadur-val',
      kostir: kostir.map(function (k) { return { gildi: k[0], heiti: k[1], valid: lesa() === k[0] }; }) }));
  }

  /* 15.10: Takka-hamur (section setting "takkar" -> data-takkar): the Festing step is hidden and its three choices (Got (2) | Got (4) | Lim) are
     pills under the preview. Same state as the Festing step (smidaVal above), so price, cart and production are the same. */
  var takkaBar = null;
  function erTakkar(ctx) { return !!(ctx && ctx.rot && ctx.rot.hasAttribute && ctx.rot.hasAttribute('data-takkar')); }
  function takkaSmida(ctx) {
    function til() { return true; }
    function pilla(k, texti, val) {
      return { k: k, t: texti, til: til, kv: function () { return ST.festing === val; }, smella: function (kv) { if (!kv) { setjaFesting(val); ctx.breytt(); } } };
    }
    return ctx.takkar({ fela: ['festing'], hopar: [{ heiti: ORD().takki_festing || t('eig_festing'), pillur: [
      pilla('festing-gat2', t('takki_gat2'), 'gat2'), pilla('festing-gat4', t('takki_gat4'), 'gat4'), pilla('festing-lim', t('takki_lim'), 'an-gata')] }] });
  }

  A.innri = { STAERDIR: STAERDIR, EFNI_ROD: EFNI_ROD, hreinsaNumer: hreinsaNumer, birtaNumer: birtaNumer, numerGilt: numerGilt, teiknaSkilti: teiknaSkilti, framleidslaSpec: framleidslaSpec, ST: ST, setjaFesting: setjaFesting, gotListi: gotListi, variantKey: variantKey, CAP_RATIO: CAP_RATIO, hladaStatic: hladaStatic, setStatic: function (j) { STATIC = j; } };

  if (typeof window !== 'undefined') {
    if (window.SMVelSida) window.SMVelSida.skra('bustadur', A);
    else (window.SMVelSidaBid = window.SMVelSidaBid || []).push(['bustadur', A]);
    window.SMBustadur = Object.assign(window.SMBustadur || {}, A);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = A;
})();
